export default "__VITE_ASSET__CHbawpuV__"